'use strict'
/**
 * fichaDelDiez.js — Contrato de la Ficha del 10 (FICHA:D6 · directriz D6 de docs/FUNDACION_LA_FICHA_DEL_10_OUTPUT_CORE.md §4).
 *
 * LO QUE TIPA: el artefacto que el §1 define como 12 contratos de output. Lo que la frontera tiene que impedir:
 *   · que falte una pieza o que lleguen en otro orden (la ficha se lee de arriba abajo: el orden es el contrato);
 *   · que una pieza `servida` llegue sin `fuente` — una cifra sin fila detrás es una cifra inventada (ADN §4);
 *   · que una pieza `sin_fuente` llegue con contenido — el hueco se nombra, no se rellena con texto plausible.
 *
 * PRODUCTOR: src/engine/ficha/fichaDelDiez.js · GET /api/ficha/:userId
 * CONSUMIDOR: la pantalla de la ficha (después) y Prime Review dominical.
 */

const { z } = require('./z')

/** De dónde sale cada afirmación de la pieza: filas reales (tabla + clave), ids de la KB y los motores que se llamaron. */
const FuenteSchema = z
  .object({
    filas: z.array(z.object({ tabla: z.string().min(1) }).passthrough()).default([]),
    kb: z.array(z.string()).default([]),
    motor: z.array(z.string()).default([]),
  })
  .passthrough()

/** Una de las 12 piezas del §1. `contenido` es null exactamente cuando el estado es `sin_fuente`. */
const PiezaFichaSchema = z
  .object({
    id: z.number().int().min(1).max(12),
    titulo: z.string().min(1),
    estado: z.enum(['servida', 'sin_fuente']),
    contenido: z.any().nullable(),
    fuente: FuenteSchema.nullable(),
    porque: z.string().min(1),
  })
  .passthrough()
  .superRefine((p, ctx) => {
    if (p.estado === 'servida') {
      if (p.contenido == null) ctx.addIssue({ code: 'custom', path: ['contenido'], message: `pieza ${p.id} servida sin contenido` })
      if (p.fuente == null) ctx.addIssue({ code: 'custom', path: ['fuente'], message: `pieza ${p.id} servida sin fuente: una cifra sin fila detrás está inventada` })
      else if (!p.fuente.filas.length && !p.fuente.kb.length) {
        ctx.addIssue({ code: 'custom', path: ['fuente'], message: `pieza ${p.id} servida sin ninguna fila ni id de KB que la respalde` })
      }
    } else {
      if (p.contenido != null) ctx.addIssue({ code: 'custom', path: ['contenido'], message: `pieza ${p.id} sin fuente pero con contenido: el hueco se nombra, no se rellena` })
    }
  })

const MotivoFichaSchema = z.enum(['alta', 'domingo', 'peticion'])

/** El artefacto completo: 12 piezas, en el orden del §1. */
const FichaDelDiezSchema = z
  .object({
    generada_en: z.string().min(1),
    motivo: MotivoFichaSchema,
    dia_del_usuario: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    piezas: z.array(PiezaFichaSchema).length(12),
    cuenta: z.object({ servidas: z.number().int(), sin_fuente: z.number().int() }).passthrough(),
    sin_fuente: z.array(z.object({ id: z.number().int(), titulo: z.string(), porque: z.string().min(1) }).passthrough()),
  })
  .passthrough()
  .superRefine((f, ctx) => {
    f.piezas.forEach((p, i) => {
      if (p.id !== i + 1) ctx.addIssue({ code: 'custom', path: ['piezas', i, 'id'], message: `la pieza ${i + 1} del §1 llegó con id ${p.id}: el orden es el contrato` })
    })
  })

/** Lo que devuelve GET /api/ficha/:userId. */
const FichaResponseSchema = z
  .object({
    ok: z.literal(true),
    ficha: FichaDelDiezSchema,
    generada_en: z.string().min(1),
    motivo: MotivoFichaSchema,
  })
  .passthrough()

module.exports = { FuenteSchema, PiezaFichaSchema, MotivoFichaSchema, FichaDelDiezSchema, FichaResponseSchema }
